import { render } from "./NewsCarousel.vue?vue&type=template&id=7adf7205&scoped=true"
import script from "./NewsCarousel.vue?vue&type=script&lang=js"
export * from "./NewsCarousel.vue?vue&type=script&lang=js"

import "./NewsCarousel.vue?vue&type=style&index=0&id=7adf7205&scoped=true&lang=css"

import exportComponent from "C:\\ami-website\\www\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7adf7205"]])

export default __exports__